import { combineReducers } from "redux-immutable";
import conditionReducer from "./condition";

export default combineReducers({
	condition: conditionReducer
});
